import React, {useState} from "react";
import {Button, Col, Row} from "react-bootstrap";
import TemplateAnketa from "../../components/templates/TemplateAnketa";
import FormAnketa from "./FormAnketa";
import {PrintAll} from "../../components/utils/PrintAll";
import {PrintElem} from "../../components/utils/PrintElem";
// import './docGen.css';

export default function GenAnketa({defaultData}) {
  // console.log('GenProtokol defaultData', defaultData)

  const [templateData, setTemplateData] = useState(
    defaultData?.length
      ? [...defaultData]
      : [
          {
            num1: "",
            num2: "",
            course: "Курс",
            date: "2021-11-11",
            namePredsedatel: "Имя 1",
            name_Chel_com: "Имя 2",
            nameSecretar: "Имя 3",
            users: [{name: "Имя 4", testPr: "", testBall: "", sobBilet: "", sobBall: ""}],
          },
        ],
  );

  // console.log('GenProtokol templateData', templateData)

  return (
    <Row>
      <Col md={"5"}>
        <h2>Анкета</h2>
      </Col>
      <Col md={"7"}>
        <PrintAll Template={[TemplateAnketa]} templateData={templateData} />
      </Col>
      <hr />
      {templateData?.map((val, index) => {
        // console.log("templateData val", val)
        return (
          <Row key={index}>
            <FormAnketa
              index={index}
              templateData={templateData}
              setTemplateData={setTemplateData}
              defaultData={val}
            />
            <Col md={"7"} key={index}>
              <h3>
                Пример{" "}
                <Button onClick={() => PrintElem("contentAnketa" + index)} size={"sm"}>
                  Печать
                </Button>
              </h3>
              <div id={"contentAnketa" + index} className={"PrintPreview"}>
                <div
                  className="wrapperPrint body2"
                  dangerouslySetInnerHTML={{__html: TemplateAnketa(val)}}
                />
              </div>
            </Col>
            <hr />
          </Row>
        );
      })}
    </Row>
  );
}
